/*
 * @Author: wangxiaosui
 * @Email: wangxiaosui1@jd.com
 * @Date: 2022-02-15 15:41:00
 * @LastEditors: wangxiaosui
 * @LastEditTime: 2022-03-07 17:38:46
 * @Descripttion: 头部注释
 */
import { groupFieldInitData, parseField } from '@retailfe/retail-utils'
import montageToSchema from './../transform/montageToSchema/edit'
import { isNull } from 'lodash'
import {
    addRelation,
    addRelationFieldValue,
    addRelationFieldList,
    FormCreatValidate
} from '../fieldRelation'

export default {
    data() {
        return {
            montageToSchema,
            groupFieldInitData,
            formRules: []
        }
    },
    methods: {
        getFormData(montageTemplateList, res) {
            // 如果有保存的数据，数据需回填
            let saveForm = {},
                { info = {} } = res
            for (let key in info) {
                !isNull(info[key]) && (saveForm[key] = info[key])
            }
            // 合并表单和已保存数据
            return {
                ...parseField(
                    montageTemplateList
                        .map(template =>
                            montageToSchema(template.templateFieldParamList)
                        )
                        .flat()
                ),
                ...saveForm
            }
        },
        getFormInstace(renderContainerInstance) {
            return renderContainerInstance.$children[0].$refs.searchForm
        },
        getSchemaObject(montageTemplateList, formData, businessParams) {
            let schemaObject = {}
            montageTemplateList.map(template => {
                schemaObject[template._id] = groupFieldInitData(
                    montageToSchema(
                        template.templateFieldParamList,
                        businessParams
                    ),
                    formData
                )
            })
            return schemaObject
        },
        addRelation(res, businessParams) {
            return addRelation(res, businessParams, montageToSchema)
        },
        addRelationFieldValue(formData, currentFormFieldList) {
            return addRelationFieldValue(formData, currentFormFieldList)
        },
        addRelationFieldList(currentFormFieldList, formData) {
            return addRelationFieldList(currentFormFieldList, formData)
        },
        FormCreatValidate(formData, currentFormFieldList) {
            return FormCreatValidate(formData, currentFormFieldList)
        }
    }
}
